__turbopack_context__.v({
  "cardContainer": "Skeleton-module__7JASyG__cardContainer",
  "cardContent": "Skeleton-module__7JASyG__cardContent",
  "circular": "Skeleton-module__7JASyG__circular",
  "none": "Skeleton-module__7JASyG__none",
  "pulse": "Skeleton-module__7JASyG__pulse",
  "rectangular": "Skeleton-module__7JASyG__rectangular",
  "rounded": "Skeleton-module__7JASyG__rounded",
  "skeleton": "Skeleton-module__7JASyG__skeleton",
  "text": "Skeleton-module__7JASyG__text",
  "textContainer": "Skeleton-module__7JASyG__textContainer",
  "wave": "Skeleton-module__7JASyG__wave",
});
